export type IntervalResolution = 'today' | 'week' | 'month';

export const calculateDateRange = (resolution: IntervalResolution): string => {
    const fromDate = new Date();

    if (resolution === 'today') {
        fromDate.setUTCHours(0, 0, 0, 0);
    } else if (resolution === 'week') {
        fromDate.setUTCDate(fromDate.getUTCDate() - 7);
    } else if (resolution === 'month') {
        fromDate.setUTCMonth(fromDate.getUTCMonth() - 1);
    }

    return fromDate.toISOString();
};
